import { t } from "@hakili/i18n";
import { Button, Callout } from "@hakili/ui";
import type { ReactElement } from "react";

import { COMPOSER_WARN_ICON } from "./composer.js";

/**
 * `SYNTHESE-READ-FAILURE` (D-1030-1, A5; the architect's rulings of 30 October): **a failed offer read is never silent.** The offer door feeds the
 * synthesis's fees, the expertised value and the vehicle's year (and, from the stage « revue », the composer and the offer panels). When that read
 * FAILS the page used to draw a dash, the same dash as a file that carries no fee (`A47`). This is the notice that stands in its place: D2's warn
 * callout (the kit's `Callout`, the alert icon of every warn notice, `COMPOSER_WARN_ICON`, frame 210) with the bay's own failure words
 * (`bank.bay.erreurTitre`), a body that names the offer, and « Réessayer ». The figures it stands for are withheld, never dashed.
 */
export function OfferReadFailure(props: { readonly onRetry: () => void }): ReactElement {
  return (
    <div role="alert">
      <Callout tone="warn" icon={COMPOSER_WARN_ICON} className="mb-3" testId="bank-offre-indisponible">
        <b className="block">{t("bank.bay.erreurTitre")}</b>
        <p className="mt-1">{t("bank.synthese.offreErreurCorps")}</p>
        <Button
          size="sm"
          variant="secondary"
          className="mt-3"
          onClick={props.onRetry}
          data-testid="bank-offre-reessayer"
        >
          {t("common.action.reessayer")}
        </Button>
      </Callout>
    </div>
  );
}
